$ = require 'jquery'
{ track } = require '@trello/analytics'
log = require 'app/scripts/debug/log'
Util = require 'app/scripts/lib/util'
ArchivedModelView = require 'app/scripts/views/archive/archived-model-view'
{ maybeDisplayLimitsErrorOnCardOpen } = require 'app/scripts/views/card/card-limits-error'
template = require 'app/scripts/views/templates/archive_item'
{ Analytics } = require '@trello/atlassian-analytics'
{ featureFlagClient } = require '@trello/feature-flag-client'

module.exports = class ArchivedListView extends ArchivedModelView

  initialize: ->
    @sendGASEvent = featureFlagClient.get('dataeng.gasv3-event-tracking', false)

  reopen: (e) ->
    Util.preventDefault(e)

    hasAttachments = false
    @model.cardList.forEach (card) ->
      numAttachments = card.get('badges')?.attachments ? 0
      hasAttachments = hasAttachments || numAttachments > 0

    options = {
      $elem: $(e.target),
      hasAttachments: hasAttachments,
      destinationBoard: @model.getBoard(),
    }
    if maybeDisplayLimitsErrorOnCardOpen(options)
      return

    @model.update { closed: false }, (err) =>
      if err?
        @model.update { closed: true }
        track('List', "Reopen", "Via Archive", "Failed")
        if @sendGASEvent
          Analytics.sendTrackEvent
            action: 'reopened',
            actionSubject: 'list'
            source: 'archiveScreen'
            containers:
              list:
                id: @model.id
              board:
                id: @model.getBoard().id
            attributes:
              succeeded: false
        throw err
      else
        track('List', "Reopen", "Via Archive")
        if @sendGASEvent
          Analytics.sendTrackEvent
            action: 'reopened',
            actionSubject: 'list'
            source: 'archiveScreen'
            containers:
              list:
                id: @model.id
              board:
                id: @model.getBoard().id
            attributes:
              succeeded: true
    false

  render: ->
    @$el.html template({
      name: @model.get('name')
      url: @model.getUrl?()
      reOpenText: @options.reOpenText
      canDelete: @canDelete()
      canReopen: @canReopen()
      canLeave: @canLeave()
      deleting: @model.isDeleting?()
    })

    @
